import { defineComponent, ref, computed, onMounted, openBlock, createElementBlock, createVNode, unref, withCtx, renderSlot, createTextVNode, createElementVNode, toDisplayString, createCommentVNode, createBlock, withDirectives, vShow, Fragment, renderList, normalizeClass, withModifiers } from "vue";
import { CdrFormGroup } from "@rei/cedar";
import _sfc_main$1 from "../BuyBoxSizeDropdown/BuyBoxSizeDropdown.mjs";
const _hoisted_1 = {
  class: "size-selector"
};
const _hoisted_2 = {
  key: 0,
  class: "size-selector__select"
};
const _hoisted_3 = {
  key: 0,
  class: "size-selector__fit-guidance"
};
const _hoisted_4 = {
  class: "size-selector__fit-guidance-value"
};
const _hoisted_5 = {
  id: "size-button-label",
  class: "size-selector__size-label"
};
const _hoisted_6 = {
  class: "pdp-sr-only"
};
const _hoisted_7 = {
  id: "size-selector-label",
  "aria-hidden": "true"
};
const _hoisted_8 = {
  class: "size-selector__size-text"
};
const _hoisted_9 = {
  class: "size-selector__selected-size"
};
const _hoisted_10 = {
  ref: "sizeSelectorSoldOut",
  class: "size-selector__sold-out-text"
};
const _hoisted_11 = {
  key: 0,
  class: "size-selector__fit-guidance"
};
const _hoisted_12 = {
  class: "size-selector__fit-guidance-value"
};
const _hoisted_13 = ["data-ui", "aria-current", "data-skus-size", "onClick", "onMouseover", "onFocusin"];
const _hoisted_14 = {
  "aria-hidden": "true"
};
const _hoisted_15 = {
  class: "pdp-sr-only"
};
const _hoisted_16 = {
  id: "size-error-text",
  class: "size-selector__error-message"
};
const _hoisted_17 = {
  class: "pdp-sr-only"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxSizeSelector",
  props: {
    error: {
      type: Boolean
    },
    groupedSizes: {},
    dropdownSizes: {},
    hoverSize: {
      default: ""
    },
    showDropdown: {
      type: Boolean
    },
    sizeLabelName: {},
    selectedSizeIsAvailable: {
      type: Boolean
    },
    selectedSize: {
      default: ""
    },
    selectedPrice: {
      default: void 0
    },
    skusForSize: {},
    enableSoldOutSizes: {
      type: Boolean
    },
    enableReviewsFitGuidance: {
      type: Boolean
    },
    overallFitValue: {
      default: void 0
    }
  },
  emits: ["registerRef", "sizeHover", "sizeUpdate"],
  setup(__props, {
    emit: __emit
  }) {
    const sizeButtons = ref(null);
    const props = __props;
    const emit = __emit;
    const showPriceHeading = computed(() => props.groupedSizes.length > 1);
    const selectSizeText = computed(() => displaySize.value ? `${props.sizeLabelName}: ` : `Select a ${props.sizeLabelName.toLowerCase()}`);
    const displaySize = computed(() => props.selectedSize || props.hoverSize);
    const srText = computed(() => {
      if (props.selectedSize) {
        const message = `${props.sizeLabelName}: ${displaySize.value}${!props.selectedSizeIsAvailable ? ", sold out" : ""}`;
        return message;
      }
      return `please select a ${props.sizeLabelName}`;
    });
    onMounted(() => {
      var _a;
      if (!props.showDropdown) emit("registerRef", {
        type: "size",
        value: (_a = sizeButtons == null ? void 0 : sizeButtons.value) == null ? void 0 : _a.$el
      });
    });
    const formatSizeText = (sizeName) => sizeName.replace(/(IN Waist | IN Inseam)/g, "");
    const formatPrice = (price) => `$${price.toFixed(2)}`;
    const handleSizeHover = (size, price) => emit("sizeHover", {
      size,
      price
    });
    const handleSizeChange = (size, price) => {
      emit("sizeUpdate", {
        newSize: size,
        newPrice: price,
        metrics: {
          linkName: "select size"
        }
      });
    };
    const getAvailabilityText = ({
      available = false
    } = {}) => available ? "available" : "unavailable";
    const getSkusForSizeList = (size) => {
      var _a;
      return (_a = props.skusForSize[size == null ? void 0 : size.name]) == null ? void 0 : _a.join(",");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [_ctx.showDropdown ? (openBlock(), createElementBlock("div", _hoisted_2, [createVNode(unref(_sfc_main$1), {
        available: _ctx.dropdownSizes.available,
        unavailable: _ctx.dropdownSizes.unavailable,
        "unavailable-for-all-sizes": _ctx.dropdownSizes.unavailableForAll,
        error: _ctx.error,
        label: _ctx.sizeLabelName,
        "selected-size": _ctx.selectedSize,
        "skus-for-size": _ctx.skusForSize,
        "enable-sold-out-sizes": _ctx.enableSoldOutSizes,
        "select-id": "size-dropdown",
        onUpdate: handleSizeChange,
        onRegisterRef: _cache[0] || (_cache[0] = (ref2) => _ctx.$emit("registerRef", ref2))
      }, {
        link: withCtx(() => [renderSlot(_ctx.$slots, "link", {}, void 0, true)]),
        subtitle: withCtx(() => [_ctx.enableReviewsFitGuidance ? (openBlock(), createElementBlock("div", _hoisted_3, [_cache[3] || (_cache[3] = createTextVNode(" Fits ")), createElementVNode("span", _hoisted_4, toDisplayString(_ctx.overallFitValue.textValue), 1), _cache[4] || (_cache[4] = createTextVNode(" based on reviews "))])) : createCommentVNode("", true)]),
        _: 3
      }, 8, ["available", "unavailable", "unavailable-for-all-sizes", "error", "label", "selected-size", "skus-for-size", "enable-sold-out-sizes"])])) : createCommentVNode("", true), !_ctx.showDropdown ? (openBlock(), createBlock(unref(CdrFormGroup), {
        key: 1,
        id: "size-thumbnails",
        ref_key: "sizeButtons",
        ref: sizeButtons,
        "data-ui": "size-selector-fieldset",
        error: _ctx.error,
        "error-role": "text",
        tabindex: _ctx.error ? "-1" : null,
        "aria-labelledby": "size-selector-label",
        "aria-describedby": _ctx.error ? "size-error-text" : null
      }, {
        label: withCtx(() => [createElementVNode("div", _hoisted_5, [createElementVNode("span", _hoisted_6, toDisplayString(srText.value), 1), createElementVNode("span", _hoisted_7, [createElementVNode("span", _hoisted_8, [createTextVNode(toDisplayString(selectSizeText.value) + " ", 1), createElementVNode("span", _hoisted_9, toDisplayString(displaySize.value), 1), withDirectives(createElementVNode("span", _hoisted_10, " - Sold out ", 512), [[vShow, !_ctx.selectedSizeIsAvailable]])])]), renderSlot(_ctx.$slots, "link", {}, void 0, true)]), _ctx.enableReviewsFitGuidance ? (openBlock(), createElementBlock("div", _hoisted_11, [_cache[5] || (_cache[5] = createTextVNode(" Fits ")), createElementVNode("span", _hoisted_12, toDisplayString(_ctx.overallFitValue.textValue), 1), _cache[6] || (_cache[6] = createTextVNode(" based on reviews "))])) : createCommentVNode("", true)]),
        error: withCtx(() => [createElementVNode("span", _hoisted_16, [createTextVNode(" Please select an available " + toDisplayString(_ctx.sizeLabelName.toLowerCase()) + " ", 1), withDirectives(createElementVNode("span", _hoisted_17, " , current selected size is sold out' ", 512), [[vShow, !_ctx.selectedSizeIsAvailable]])])]),
        default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groupedSizes, (group) => {
          return openBlock(), createElementBlock("div", {
            key: _ctx.groupedSizes.length > 1 ? group.priceData.price.value : "singlePrice"
          }, [showPriceHeading.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["size-selector__size-price-heading", {
              "size-selector__size-price-heading--sale": group.priceData.price.sale
            }]),
            "data-ui": "size-price-heading"
          }, toDisplayString(formatPrice(group.priceData.price.value)), 3)) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(group.sizes, (size) => {
            return openBlock(), createElementBlock("button", {
              key: size.name + (group.priceData ? group.priceData.price.value : ""),
              type: "button",
              class: normalizeClass(["size-selector__size-button", {
                "size-selector__size-button--unavailable": !size.available,
                "size-selector__size-button--selected": (!group.priceData || _ctx.selectedPrice === group.priceData.price.value) && _ctx.selectedSize === size.name
              }]),
              "data-ui": `size-selector-button:${getAvailabilityText(size)}`,
              "aria-current": (!group.priceData || _ctx.selectedPrice === group.priceData.price.value) && _ctx.selectedSize === size.name,
              "data-skus-size": getSkusForSizeList(size),
              onClick: withModifiers(($event) => handleSizeChange(size.name, group.priceData), ["prevent"]),
              onMouseover: ($event) => handleSizeHover(size.name, group.priceData),
              onMouseout: _cache[1] || (_cache[1] = ($event) => handleSizeHover()),
              onFocusin: ($event) => handleSizeHover(size.name),
              onFocusout: _cache[2] || (_cache[2] = ($event) => handleSizeHover())
            }, [createElementVNode("span", _hoisted_14, toDisplayString(formatSizeText(size.name)), 1), createElementVNode("span", _hoisted_15, toDisplayString(size.name) + toDisplayString(size.available ? "" : ", sold out"), 1)], 42, _hoisted_13);
          }), 128))]);
        }), 128))]),
        _: 3
      }, 8, ["error", "tabindex", "aria-describedby"])) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxSizeSelector2.mjs.map
